/**
 * author: Ananthapadmanabhan V K
 */
import Multiselect from 'multiselect-react-dropdown';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Button, Dropdown, Form, Modal, OverlayTrigger, Popover } from 'react-bootstrap';
import {
  BiCalendar,
  BiCalendarAlt, BiCheckSquare,
  BiListCheck, BiListUl, BiParagraph, BiPlus, BiPlusCircle, BiRadioCircleMarked, BiText, BiTrash, BiUpload
} from "react-icons/bi";
import { BsQuestionCircle } from "react-icons/bs";
import './FormMainBody.scss';

import * as Icons from "react-icons/bi";

import "react-datepicker/dist/react-datepicker.css";
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { CompanyContext, GlbFormContext, LoaderContext } from "../../App";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import FormHeader from '../../components/Form/FormHeader';
import FormSidebar from '../../components/Form/FormSidebar';
import { ASSESSMENTFORMTXT, ExternalDependencyType, FORMCONTROLLERSTYPE, FormOptionValidationOperator, GENERAL_FORM, QuestionType, SCORINGMETHODS } from '../../core/constants/common';
import CarbonEmissionService from '../../core/services/CarbonEmissionService';
import FormService from '../../core/services/FormService';
import FormEditService from '../../core/services/FromEditService';
import Utils from '../../core/utilities/Utils';
import DeleteSectionModal from '../DeleteSectionModal/DeleteSectionModal';
import FormCreate from '../FormCreate/FormCreate';
import QuestionLogicForm from '../Question/QuestionLogicForm';

import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import the styles
import GridTable from '../../components/RadioGridView/GridTable';

const FormMainBody = () => {
  const optionObj = {
    name: null,
    score: null,
    valueCode: null,
    sortOrder: 100,
    showOthers: false,
    othersMandatory: false,
    showRemarks: false,
    remarksMandatory: false,
    helpText: null
  };
  const actionsArrObj = {
    formOption: {
      id: null
    },
    formField: null,
    types: [],
    emailIds: [],
    emailMessage: null,
    notification: "",
    task: ""
  }
  const { id } = useParams();
  const { langId } = useParams();
  const [formdata, setFormData] = useState('');
  const [formsectionsdata, setFormSectionsData] = useState('');
  const [currentsection, setCurrentSection] = useState("");
  const [sectionname, setSectionName] = useState('');
  const [sectiondesp, setSectionDesp] = useState('');
  const [scoringmethod, setScoringMethod] = useState('');
  const [weightage, setWeightage] = useState('');
  const [uom_popup, setUomPopup] = useState('');
  const [field, setField] = useState('');
  const [show, setShow] = useState(false);
  const [showquestion, setShowQuestion] = useState(false);
  const [showquestionedit, setShowQuestionEdit] = useState(false);
  const [showanswertype, setShowAnswerType] = useState(false);
  const [selectedanswertype, setSelectedAnsType] = useState('');
  const [choiceoptions, setChoiceOptions] = useState([optionObj]);
  const [fieldeditid, setFieldEditId] = useState('');
  const [optional, setOptional] = useState(true);
  const [scoreEnabled, setScoreEnabled] = useState(false);
  const [submitlanguage, setSubmitLanguage, getSubmitLanguage] = useState("");
  const [editedSectionId, setEditedSectionId] = useState("");
  const [tabchoosed, setTabChoosed] = useState('edit');
  const [actionsarray, setActionsArray] = useState([actionsArrObj]);
  const [validated, setValidated] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [iswithinsection, setIsWithInSection] = useState(true);
  const [actionType, setActionType] = useState("");
  const [selParentSection, setSelParentSection] = useState("");
  const [allSections, setAllSections] = useState([]);
  const [helpText, setHelpText] = useState(Utils.getHelpTextPlaceHolder());
  const [pageHelpText, setPageHelpText] = useState("");
  const [otherChecked, setOtherChecked] = useState(false);
  const [otherText, setOtherText] = useState("");
  const [otherMandatory, setOtherMandatory] = useState(false);
  const [remarksArr, setRemarksArr] = useState([]);
  const [remarkTitle, setRemarkTitle] = useState("");
  const [remarkRequired, setRemarkRequired] = useState(false);
  const [allowRemark, setAllowRemark] = useState(false);
  const [isSubsection, setIsSubsection] = useState(false);
  const [changeorder, setChangeOrder] = useState([]);
  const [deleteItem, setDeleteItem] = useState('');
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [isDeleteSection, setIsDeleteSection] = useState(false);
  const [deleteSectionId, setDeleteSectionId] = useState('');
  const [confirmMessage, setConfirmMessage] = useState('');
  const [sidebarItemsReorderedOn, setSidebarItemsReorderedOn] = useState(0);
  const [uomRequired, setUomRequired] = useState(false);
  const [uomRequiredPopup, setUomRequiredPopup] = useState(false);
  const { glbForm, setGlbForm } = useContext(GlbFormContext);
  const { companyId } = useContext(CompanyContext);
  const { setLoaderState } = useContext(LoaderContext);
  const latestSectionRequestRef = useRef(null);
  const [uomData, setUOMData] = useState({ relevantUoms: [], defaultUOM: '' });
  const [outputUnits, setOutputUnits] = useState([]);
  const uniqueOutputUnits = useMemo(() => {
    const seen = new Set();
    return (outputUnits ?? []).filter((unit) => {
      if (seen.has(unit.value)) return false;
      seen.add(unit.value);
      return true;
    });
  }, [outputUnits]);
  const [inputUnits, setInputUnits] = useState([]);
  const [multiSupportEnabled, setMultiSupportEnabled] = useState(false);
  const [extDependency, setExtDependency] = useState({ enabled: false });
  const [emissionCats, setEmissionCats] = useState([]);
  const [extConfig, setExtConfig] = useState('');
  const [editEnable, setEditEnable] = useState(true);
  const [allowFileUpload, setAllowFileUpload] = useState(false);
  const [fileMandatory, setFileMandatory] = useState(false);
  const [allowComments, setAllowComments] = useState(false);
  const [hisDataSupported, setHisDataSupported] = useState(false);
  const [optionSelectionValidation, setOptionSelectionValidation] = useState({
    operator: null,
    count: null,
    maximumCount: null,
    validationMessage: null
  });
  const [gridData, setGridData] = useState({ columns: [], rowSets: [] });

  const handleClose = () => {
    setShow(false);
    setUomRequiredPopup(false);
    setMultiSupportEnabled(false);
  };

  const handleShow = () => {
    setEditEnable(false)
    setValidated(false);
    setSectionName('');
    setSectionDesp('');
    setEditedSectionId(null);
    setWeightage('');
    setScoringMethod('NONE')
    resetFieldProperties();
    setActionType(1); // section
    setSelParentSection("");
    setShow(true);


  };
  const handleShowSubSection = (formId) => {
    setEditEnable(false)
    getAllSections(formId);
    setValidated(false);
    setSectionName("");
    setSectionDesp("");
    setEditedSectionId(null);
    setWeightage("");
    setScoringMethod("NONE");
    setUomRequiredPopup(false);
    setUomPopup("");
    resetFieldProperties();
    setActionType(2); //subsection
    setSelParentSection(currentsection || "");
    setShow(true);
  };
  const [updateform, setUpdateForm] = useState(false);

  const Icon = props => {
    const { iconName, size, color } = props;
    const icon = React.createElement(Icons[iconName]);
    return <div style={{ fontSize: size, color: color }}>{icon}</div>;
  };

  const handleQuestionShow = (isWithSection) => {
    setIsWithInSection(isWithSection);
    resetFieldProperties();
    setShowAnswerType(true);
  };

  useEffect(() => {
    getFormDetails({ fetchFor: 'INITIAL', lang: langId });
    getLanguages();
  }, []);

  useEffect(() => {
    if (companyId >= 0) {
      loadUnitsOfMeasure();
    }
  }, [companyId]);

  const getLanguages = () => {
    FormService.getLanguages()
      .then((response) => {
        setLanguages(response.data);
      })
      .catch((error) => {
      });
  };

  const getFormDetails = ({ fetchFor, lang, sectionId, fieldId = null }) => {
    FormEditService.getFormDetails(id, lang)
      .then((response) => {
        setChangeOrder([]);
        setFormData(response.data);
        setGlbForm(response.data);
        setSubmitLanguage(response.data.selectedLanguage.id);
        if (response.data.fields.length > 0 && fetchFor === 'NO_SECTION') {
          setIsWithInSection(false);
          let obj = {
            sectionAvailable: false,
            fields: response.data.fields
          };
          setFormSectionsData(obj);
        } else if (fetchFor === 'NO_SECTION') {
          fetchFor = 'INITIAL';
        }

        if (fetchFor === 'INITIAL') {
          if (response.data.fields.length > 0) {
            setIsWithInSection(false);
            let obj = {
              sectionAvailable: false,
              fields: response.data.fields
            };
            setFormSectionsData(obj);
          } else if (response.data.sections.length > 0) {
            getSectionDetails(response.data.sections.sort((a, b) => a.sortOrder - b.sortOrder)[0].id, null, lang);
          }
        } else if (fetchFor === 'EDIT_SECTION') {
          getSectionDetails(sectionId, fieldId, lang);
        }
      })
      .catch((error) => {
      });
  };

  const getFieldWithoutSection = (id) => {
    setIsWithInSection(false);
    let obj = {
      sectionAvailable: false,
      fields: formdata.fields
    };
    setFormSectionsData(obj);
  }
  const getSectionDetails = (sectionId, fieldEditedId, lang) => {
    setCurrentSection(sectionId);
    const requestId = {};
    latestSectionRequestRef.current = requestId;
    setLoaderState?.({ display: true, type: 'TEXTUAL' });
    FormEditService.getSectionDetails(id, sectionId, lang)
      .then((response) => {
        if (latestSectionRequestRef.current === requestId) {
          setLoaderState?.({ display: false });
        }
        let responseData = response.data;
        responseData['sectionAvailable'] = true;
        setFormSectionsData(responseData);
        if (fieldEditedId != null) {
          let filtereddata = response.data.fields.filter(x => x.id === fieldEditedId);
          if (filtereddata[0]) {
            editField(filtereddata[0]);
          }
        }

      })
      .catch((error) => {
        if (latestSectionRequestRef.current === requestId) {
          setLoaderState?.({ display: false });
        }
      });
  };

  const handleCreateSectionForm = (e) => {
    e.preventDefault();
    let form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      let params = {
        title: sectionname,
        description: sectiondesp,
        layout: "INLINE",
        displayTitle: true,
        sortOrder: 100,
        pageHelpText: pageHelpText,
      };
      if (actionType === 2) {
        params["parentSection"] = {
          id: parseInt(selParentSection),
        };

      }
      if (formdata.formType === ASSESSMENTFORMTXT || formdata.formType === GENERAL_FORM) {
        params['weightage'] = weightage;
        params['scoringMethod'] = scoringmethod;
      };
      if (submitlanguage != null && submitlanguage !== '' && submitlanguage !== undefined) {
        params['selectedLanguage'] = {
          id: submitlanguage
        }
      };
      if (uomRequiredPopup) {
        params['uom'] = uom_popup
      };
      if (multiSupportEnabled) {
        params['multiSupportEnabled'] = multiSupportEnabled;
      };
      FormEditService.createSection(id, params, editedSectionId)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            getFormDetails({
              fetchFor: 'EDIT_SECTION',
              lang: submitlanguage,
              sectionId: editedSectionId > 0 ? editedSectionId : response.data.id
            });
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            handleClose();
          }
        })
        .catch((error) => {
        });
    }
    setValidated(true);
  };

  const handleSaveField = (isEdit) => {
    var sectionId = formsectionsdata.id;
    var params = null;
    if (isOptionsBasedAnswer()) {
      if (remarksArr) {
        choiceoptions.map(x => {
          const flag = remarksArr.find(y => y.id === x.id)
          if (flag) {
            x.showRemarks = true;
            x.remarksMandatory = remarkRequired ? true : false;
          }
          else {
            x.showRemarks = false;
            x.remarksMandatory = false;
          }

        })
      }
      params = {
        name: field,
        sortOrder: 100,
        fieldHelpText: helpText,
        type: selectedanswertype,
        optional: optional,
        active: true,
        randomize: false,
        allowOtherOption: otherChecked,
        otherTextLabel: otherText,
        otherFieldValidation: {
          mandatory: otherMandatory,
          validationMessage: null
        },
        allowRemark: remarksArr.length > 0 || allowComments ? true : false,
        remarkMandatory: remarkRequired,
        remarkLabel: remarksArr.length > 0 ? remarkTitle : '',
        remarkFieldValidation: {
          mandatory: false,
          validationMessage: null
        },
        scoreEnabled: scoreEnabled,
        responseAcknowledgement: null,
        selectedLanguage: {
          id: submitlanguage
        },
        options: choiceoptions,
        uomRequired: uomRequired,
        extDependency: extDependency.enabled ? extDependency.value : null,
        extConfig: extConfig ?? null,
        allowFileUpload: allowFileUpload,
        fileMandatory: fileMandatory,
        historicalDataSupported: hisDataSupported,
        gridConfig: constructGridConfigPayload(),
        optionSelectionValidation: (optionSelectionValidation.operator && optionSelectionValidation.count) ? {
          operator: optionSelectionValidation.operator,
          count: optionSelectionValidation.count,
          maximumCount: optionSelectionValidation.maximumCount || null,
          validationMessage: optionSelectionValidation.validationMessage || null
        } : null
      }
    } else {
      params = {
        name: field,
        optional: optional,
        active: true,
        type: selectedanswertype,
        displayTitle: true,
        sortOrder: 100,
        fieldHelpText: helpText,
        selectedLanguage: {
          id: submitlanguage
        },
        uomRequired: uomRequired,
        relevantUoms: uomData.relevantUoms,
        defaultUOM: uomData.defaultUOM,
        extDependency: extDependency.enabled ? extDependency.value : null,
        extConfig: extConfig ?? null,
        allowFileUpload: allowFileUpload,
        fileMandatory: fileMandatory,
        allowRemark: remarksArr.length > 0 || allowComments ? true : false,
        remarkMandatory: remarkRequired,
        historicalDataSupported: hisDataSupported,
        scoreEnabled: selectedanswertype === QuestionType.FILE_UPLOAD ? scoreEnabled : false,
      };
    }
    if (fieldeditid !== '' && fieldeditid !== null) {
      params['id'] = fieldeditid;
    }
    if (iswithinsection) {
      saveFieldWithSection(sectionId, params, isEdit);
    } else {
      saveFieldWithoutSection(params, isEdit);
    }

  };

  const saveFieldWithSection = (sectionId, params, isEdit) => {
    FormEditService.createField(id, sectionId, params)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          getFormDetails({
            fetchFor: 'EDIT_SECTION',
            lang: submitlanguage,
            sectionId: sectionId
          });
          resetFieldProperties();
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
      });
  }

  const saveFieldWithoutSection = (params, isEdit, saveAsDraft = true) => {
    FormEditService.createUpdateFieldWithoutSection(id, params, isEdit, saveAsDraft)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          getFormDetails({ fetchFor: 'NO_SECTION', lang: submitlanguage });
          resetFieldProperties();
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
      });
  }

  const addChoice = () => {
    let arr = [...choiceoptions];
    arr.push(optionObj);
    setChoiceOptions(arr);
  };
  const removeChoice = (index) => {
    var array = [...choiceoptions];
    array.splice(index, 1);
    setChoiceOptions(array);
  };

  const updateFieldChanged = (index) => (e) => {
    const newArr = choiceoptions.map((item, i) => {
      if (index === i) {
        return { ...item, [e.target.name]: e.target.value };
      } else {
        return item;
      }
    });
    setChoiceOptions(newArr);
  };

  const editField = (item) => {
    setShowAnswerType(false);
    resetFieldProperties();
    if (item.type === 'MULTI_SELECT_DROP_DOWN' || item.type === 'DROP_DOWN' || item.type === 'RADIO' || item.type === 'MULTIPLE_CHOICE') {
      setChoiceOptions(item.options);
    }

    if (item.type === 'RADIO_GRID') {
      const columns = item.gridConfig.columns.map(col => ({
        id: col.id,
        name: col.name,
        sortOrder: col.sortOrder
      }));

      const rowSets = item.gridConfig.rows.map(row => ({
        id: row.id,
        name: row.name,
        code: row.code,
        help: row.helpText,
        sortOrder: row.sortOrder,
        rows: item.gridConfig.columns.map(col => {
          const cellOption = row.cellOptions.find(option => option.columnId === col.id);
          return {
            id: cellOption ? cellOption.id : '',
            option: cellOption ? cellOption.name : '',
            score: cellOption ? cellOption.score : '',
            sortOrder: cellOption ? cellOption.sortOrder : '',
          };
        })
      }));

      setGridData({ columns, rowSets });
    }

    setFieldEditId(item.id);
    setField(item.name);
    setSelectedAnsType(item.type);
    setShowQuestionEdit(true);
    setOptional(item.optional);
    setScoreEnabled(item.scoreEnabled);
    setHelpText(item.fieldHelpText);
    setOtherChecked(item.allowOtherOption);
    setOtherText(item.otherTextLabel);
    setRemarkTitle(item.remarkLabel);
    setRemarkRequired(item.remarkMandatory);
    setAllowRemark(item?.allowRemark);
    setOtherMandatory(item?.otherFieldValidation?.mandatory);
    let filteredOption = item.options.filter(x => x.showRemarks === true);
    setRemarksArr(filteredOption);
    setUomRequired(item.uomRequired);
    setUOMData({
      relevantUoms: item.relevantUoms ?? [],
      defaultUOM: item.defaultUOM
    });
    setExtDependency({
      enabled: item.extDependency !== null,
      value: item.extDependency ?? '',
    });
    setExtConfig(item.extConfig ?? null);
    if (item.extConfig?.emissionScope) {
      loadEmissionCats(item.extConfig?.emissionScope);
    }
    setAllowFileUpload(item.allowFileUpload);
    setFileMandatory(item.fileMandatory);
    setAllowComments(item.allowRemark);
    setHisDataSupported(item.historicalDataSupported);
    setIsWithInSection(formsectionsdata?.sectionAvailable);
    if (item.optionSelectionValidation) {
      setOptionSelectionValidation({
        operator: item.optionSelectionValidation.operator || null,
        count: item.optionSelectionValidation.count || null,
        maximumCount: item.optionSelectionValidation.maximumCount || null,
        validationMessage: item.optionSelectionValidation.validationMessage || null
      });
    } else {
      setOptionSelectionValidation({
        operator: null,
        count: null,
        maximumCount: null,
        validationMessage: null
      });
    }
  };

  const resetFieldProperties = () => {
    setTabChoosed('edit');
    setFieldEditId(null);
    setSelectedAnsType(null);
    setShowQuestionEdit(false);
    setShowQuestion(false);
    setChoiceOptions([optionObj]);
    setOptional(true);
    setScoreEnabled(false);
    setField(null);
    setHelpText(Utils.getHelpTextPlaceHolder());
    setOtherChecked(false);
    setOtherText(null);
    setRemarkTitle(null);
    setRemarkRequired(false);
    setAllowRemark(false);
    setOtherMandatory(false);
    setRemarksArr([]);

    setUomRequired(false);
    setUOMData({
      relevantUoms: [],
      defaultUOM: ''
    });
    setExtDependency({
      enabled: false, value: ''
    });
    setExtConfig(null);
    setAllowFileUpload(false);
    setAllowComments(false);
    setRemarkRequired(false);
    setOptionSelectionValidation({
      operator: null,
      count: null,
      maximumCount: null,
      validationMessage: null
    });
    setFileMandatory(false);
    setHisDataSupported(false);
  };

  const handleRequired = (val) => {
    setOptional(!val);
    if (val === false) {
      setRemarkRequired(false);
      setFileMandatory(false);
    }
  };
  const handleScoreEnable = (val) => {
    var array = [...choiceoptions];
    for (let i = 0; i < array.length; i++) {
      array[i].score = null;
    }
    setChoiceOptions(array);
    setScoreEnabled(val);
  };

  const chooseAnswerType = (type) => {
    if ((type === 'RADIO' || type === 'RADIO_GRID' || type === 'MULTI_SELECT_DROP_DOWN' || type === 'DROP_DOWN' || type === 'MULTIPLE_CHOICE')) {
      setScoreEnabled(true);
    }
    setSelectedAnsType(type);
    setShowAnswerType(false);
    setShowQuestion(true);
    if (type === 'NUMERIC_VALUE') {
      setHisDataSupported(formdata.historicalDataSupported ?? false);
    }

    if (type === 'RADIO_GRID') {
      setGridData({ columns: [], rowSets: [] });
    }
  }

  const editSection = (id) => {
    setEditedSectionId(id);
    setSectionName(formsectionsdata.title);
    setSectionDesp(formsectionsdata.description);
    setScoringMethod(formsectionsdata.scoringMethod);
    setWeightage(formsectionsdata.weightage);
    setUomPopup(formsectionsdata.uom);
    setActionType(1)
    setSidebarItemsReorderedOn()
    if (formsectionsdata.uom) {
      setUomRequiredPopup(true);
    } else {
      setUomRequiredPopup(false);
    }
    setMultiSupportEnabled(formsectionsdata.multiSupportEnabled ? true : false);
    setValidated(false);
    setShow(true);
  }
  const editSubSection = (formId, sectionId) => {
    setSelParentSection(formsectionsdata.parentSection?.id ?? '');
    getAllSections(formId);
    setEditedSectionId(sectionId);
    setSectionName(formsectionsdata.title);
    setSectionDesp(formsectionsdata.description);
    setScoringMethod(formsectionsdata.scoringMethod);
    setWeightage(formsectionsdata.weightage);
    setUomPopup(formsectionsdata.uom);
    setActionType(2)
    if (formsectionsdata.uom) {
      setUomRequiredPopup(true);
    } else {
      setUomRequiredPopup(false);
    }
    setMultiSupportEnabled(formsectionsdata.multiSupportEnabled ? true : false);
    setValidated(false);
    setShow(true);
  }
  const actionTaken = (checked, index, name) => {
    let array = [...actionsarray];
    if (checked) {
      if (Array.isArray(array[index].types)) {
        array[index].types.push(name);
      } else {
        array[index].types = [];
        array[index].types.push(name);
      }
    } else {
      array[index].types.splice(array[index].types.indexOf(name), 1);
    }
    setActionsArray(array);
  };
  const messageUpdate = (index, name, value) => {
    let array = [...actionsarray];
    array[index][name] = value;
    setActionsArray(array);
  };
  const emailUpdate = (index, name, value) => {
    let array = [...actionsarray];
    let stringArr = value.split(',');
    array[index][name] = stringArr;
    setActionsArray(array);
  };
  const chooseOption = (index, value) => {
    let array = [...actionsarray];
    array[index].formOption.id = value;
    setActionsArray(array);
  };
  const addAction = () => {
    let array = [...actionsarray];
    array.push(actionsArrObj);
    setActionsArray(array);
  };

  const callbackFn = (val) => {
    setUpdateForm(val);
    getFormDetails({ fetchFor: 'INITIAL', lang: submitlanguage });
  };

  const getActionDetails = () => {
    setActionsArray([actionsArrObj]);
    FormEditService.getActions(id, fieldeditid)
      .then((response) => {
        if (response.data.length > 0) {
          setActionsArray([...response.data]);
        }
      })
      .catch((error) => {
      });
  };

  const handleSaveActions = () => {

    let body = {
      actions: actionsarray
    }
    FormEditService.createActions(id, fieldeditid, body)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
      });
  };

  const isCheckboxChecked = (checkedArray, checkBoxVaL) => {
    if (checkedArray.types.some(e => e.Name === checkBoxVaL)) {
      return true;
    }
  };

  const isActionNeeded = () => {
    if ((selectedanswertype === 'RADIO' 
      || selectedanswertype === 'MULTI_SELECT_DROP_DOWN' 
      || selectedanswertype === 'DROP_DOWN' 
      || selectedanswertype === 'MULTIPLE_CHOICE' 
      || selectedanswertype === 'RADIO_GRID')) {
      return true;
    } else {
      return false;
    }
  }
  const getAllSections = (formId) => {
    FormEditService.getAllSections(formId)
      .then((response) => {
        setAllSections(response.data);

      })
      .catch((error) => {
      });
  };

  const handleOtherChange = (event) => {
    let val = event.currentTarget.checked;
    setOtherChecked(val);
    if (val) {
      let arr = [...choiceoptions];
      var arrObj = optionObj;
      arrObj.showOthers = true;
      arr.push(arrObj);
      setChoiceOptions(arr);
    } else {
      var array = [...choiceoptions];
      let index = array.findIndex((x) => x.showOthers === true);
      array.splice(index, 1);
      setChoiceOptions(array);
    }

  }
  const isRemarkNeeded = () => {
    if ((selectedanswertype === 'RADIO' || selectedanswertype === 'MULTI_SELECT_DROP_DOWN' || selectedanswertype === 'DROP_DOWN' || selectedanswertype === 'MULTIPLE_CHOICE' || selectedanswertype === 'RADIO_GRID')) {
      return true;
    } else {
      return false;
    }
  }
  const onSelectDeSelectML = (selectedList, selectedItem, index) => {
    let mulObjArr = [];
    let arr = [...choiceoptions];
    for (let i = 0; i < selectedList.length; i++) {
      let id = parseInt(selectedList[i].id);
      var objId = {
        id: parseInt(selectedList[i].id)
      }
      mulObjArr.push(objId);
    }
    setRemarksArr(mulObjArr);
  }
  const handleRemarkRequired = (val) => {
    setRemarkRequired(val);
  };
  const deleteField = (val) => {
    setDeleteItem(val);
    setConfirmMessage("Are you sure want to delete this field?")
    setIsConfirmModal(true);
  }
  const callbackdelete = (bool) => {
    setIsConfirmModal(false);
    if (bool) {
      const sectionId = formsectionsdata.id;
      FormEditService.deleteField(id, deleteItem.id, sectionId)
        .then((response) => {
          if (response.status === 204) {
            setDeleteItem('');
            if (sectionId) {
              getFormDetails({
                fetchFor: 'EDIT_SECTION',
                lang: submitlanguage,
                sectionId: sectionId
              });
            } else {
              getFormDetails({ fetchFor: 'NO_SECTION', lang: submitlanguage });
            }
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((error) => {
        });
    }
  }

  const deleteSection = (deleteSecId) => {
    setDeleteSectionId(deleteSecId);
    setIsDeleteSection(true);
  }
  const callbackDeleteSection = (boolVal, delType) => {
    setIsDeleteSection(false);
    if (boolVal) {
      var sectionId = deleteSectionId;
      FormEditService.deleteSection(id, deleteSectionId, delType)
        .then((response) => {
          if (response.status === 204) {
            setDeleteSectionId('');
            if (sectionId) {
              setFormSectionsData('');
              getFormDetails({ fetchFor: '', lang: submitlanguage });
            } else {
              getFormDetails({ fetchFor: 'NO_SECTION', lang: submitlanguage });
            }
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        })
        .catch((error) => {
        });
    }

  }
  const updateOtherChanged = (e) => {
    const newArr = choiceoptions.map((item, i) => {
      if (item.showOthers === true) {
        if (e.target.name === "othersMandatory") {
          let val = e.currentTarget.checked;
          setOtherMandatory(val);
          return { ...item, [e.target.name]: val };
        } else {
          return { ...item, [e.target.name]: e.target.value };
        }
      } else {
        return item;
      }
    });
    e.target.name === "name" && setOtherText(e.target.value);
    setChoiceOptions(newArr);
  }

  const handleFieldDrop = (droppedField, droppedOver, sectionId) => {
    const data = formdata;
    let deleteIndex = -1;
    let insertIndex = -1;
    const insertAsFirstFieldOfSection = droppedOver.id === 0;

    deleteIndex = data.fields?.findIndex(f => f.id === droppedField.id);
    if (deleteIndex >= 0) {
      data.fields.splice(deleteIndex, 1);
    }
    if (insertAsFirstFieldOfSection && sectionId == 0) {
      insertIndex = 0;
      data.fields.splice(0, 0, droppedField);
    } else {
      insertIndex = data.fields?.findIndex(f => f.id === droppedOver.id);
      if (insertIndex >= 0) {
        if ((insertIndex + 1) <= (data.fields.length - 1)) {
          data.fields.splice(insertIndex + 1, 0, droppedField);
        } else {
          data.fields.push(droppedField);
        }
      }
    }
    if (deleteIndex < 0 || insertIndex < 0) {
      function findAndReplaceInSections(droppedField, droppedOver, sections) {
        sections?.forEach(section => {
          let dIndex = -1;
          let iIndex = -1;
          dIndex = section.fields?.findIndex(f => f.id === droppedField.id);
          if (dIndex >= 0) {
            section.fields.splice(dIndex, 1);
          }
          if (insertAsFirstFieldOfSection && section.id === sectionId) {
            iIndex = 0;
            section.fields.splice(0, 0, droppedField);
          } else {
            iIndex = section.fields?.findIndex(f => f.id === droppedOver.id);
            if (iIndex >= 0) {
              if ((iIndex + 1) <= (section.fields.length - 1)) {
                section.fields.splice(iIndex + 1, 0, droppedField);
              } else {
                section.fields.push(droppedField);
              }
            }
          }
          if ((dIndex < 0 || iIndex < 0) && section.subSections?.length > 0) {
            findAndReplaceInSections(droppedField, droppedOver, section.subSections);
          }
        });
      }
      findAndReplaceInSections(droppedField, droppedOver, data.sections);
    }
    setFormData(data);
    setGlbForm(data);
    setSidebarItemsReorderedOn(Date.now());
    reorderField(droppedField.id, droppedOver.id, sectionId);
  };

  const handleSectionDrop = (droppedSection, droppedOverField, sectionId) => {
    const data = formdata;
    let deleteIndex = -1;
    let fieldIndex = -1;
    const insertAsFirstSectionOfSubSection = droppedOverField.id === 0;
    // First delete the section
    deleteIndex = data.sections?.findIndex(s => s.id === droppedSection.id);
    if (deleteIndex >= 0) {
      data.sections.splice(deleteIndex, 1);
    }
    if (insertAsFirstSectionOfSubSection && sectionId == 0) {
      fieldIndex = 0;
      data.sections.splice(0, 0, droppedSection);
    } else {
      // Then find the field over which the section was dropped
      fieldIndex = data.fields?.findIndex(f => f.id === droppedOverField.id);
      if (fieldIndex >= 0) {
        data.sections.splice(0, 0, droppedSection);
      }
    }
    if (deleteIndex < 0 || fieldIndex < 0) {
      function findAndReplaceSectionInSections(droppedSection, fieldId, sections) {
        sections?.forEach(section => {
          let dIndex = -1;
          let fIndex = -1;
          dIndex = section.subSections?.findIndex(s => s.id === droppedSection.id);
          if (dIndex >= 0) {
            section.subSections.splice(dIndex, 1);
          }
          if (insertAsFirstSectionOfSubSection && section.id == sectionId) {
            fIndex = 0;
            section.subSections.splice(0, 0, droppedSection);
          } else {
            fIndex = section.fields?.findIndex(f => f.id === fieldId);
            if (fIndex >= 0) {
              section.subSections.splice(0, 0, droppedSection);
            }
          }
          if ((dIndex < 0 || fIndex < 0) && section.subSections?.length > 0) {
            findAndReplaceSectionInSections(droppedSection, fieldId, section.subSections);
          }
        });
      }
      findAndReplaceSectionInSections(droppedSection, droppedOverField.id, data.sections);
    }
    setFormData(data);
    setSidebarItemsReorderedOn(Date.now());
    reorderSection(droppedSection.id, sectionId, 0);
  };

  const reorderField = (fieldId, previousFieldId, sectionId) => {
    const payload = {
      sectionId: sectionId,
      prevFieldId: previousFieldId
    };
    FormEditService.reorderField(formdata.id, fieldId, payload)
      .then(response => {
        getFormDetails({ fetchFor: 'INITIAL', lang: submitlanguage });
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }

  const reorderSection = (sectionIdToMove, sectionId, previousSectionId) => {
    const payload = {
      sectionId: sectionId,
      prevSectionId: previousSectionId
    };
    FormEditService.reorderSection(formdata.id, sectionIdToMove, payload)
      .then(response => {
        getFormDetails({ fetchFor: 'INITIAL', lang: submitlanguage });
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }

  const isNumericValueQuestion = () => {
    return selectedanswertype === 'NUMERIC_VALUE';
  }

  const getUOMRequiredCheckboxToRender = () => {
    return (
      <div>
        <input className="form-check-input me-2"
          type="checkbox"
          checked={uomRequired}
          id="uomRequired"
          onChange={(e) => setUomRequired(e.target.checked)} />
        <label className="form-check-label" htmlFor="uomRequired">
          Unit of Measure
        </label>
      </div>
    );
  };

  const getFileUploadCheckboxToRender = () => {
    return (
      <div className='File_uploadBox'>
        <input className="form-check-input me-2"
          type="checkbox"
          checked={allowFileUpload}
          id="FileRequired"
          onChange={(e) => setAllowFileUpload(e.target.checked)} />
        <label className="form-check-label" htmlFor="FileRequired">
          File Upload
        </label>
      </div>
    );
  };

  const getFileRequiredCheckboxToRender = () => {
    return (
      <div>
        <input className="form-check-input me-2"
          type="checkbox"
          checked={fileMandatory}
          id="FileRequired"
          onChange={(e) => setFileMandatory(e.target.checked)} />
        <label className="form-check-label " htmlFor="FileRequired">
          Required
        </label>
      </div>
    );
  };

  const getCommentCheckboxToRender = () => {
    return (
      <div className='Show_CommentBox'>
        <input className="form-check-input me-2"
          type="checkbox"
          checked={allowComments}
          id="showCommentRequired"
          onChange={(e) => setAllowComments(e.target.checked)} />
        <label className="form-check-label" htmlFor="showCommentRequired">
          Show Comment
        </label>
      </div>
    );
  };

  const getCommentRequiredCheckboxToRender = () => {
    return (
      <div>
        <input className="form-check-input me-2"
          type="checkbox"
          checked={remarkRequired}
          id="commentRequired"
          onChange={(e) => setRemarkRequired(e.target.checked)} />
        <label className="form-check-label " htmlFor="commentRequired">
          Required
        </label>
      </div>
    );
  };

  const getUOMRequiredCheckboxPopup = () => {
    return (
      <div className='col-md-6'>
        <input className="form-check-input me-2"
          type="checkbox"
          checked={uomRequiredPopup}
          id="uomRequiredPopup"
          onChange={(e) => setUomRequiredPopup(e.target.checked)} />
        <label className="form-check-label" htmlFor="uomRequiredPopup">
          Unit of Measure
        </label>
      </div>
    );
  };
  // required later
  // const getMultiSupportEnabledCheckboxInPopup = () => {
  //   return (
  //     <div className='col-md-6'>
  //       <input className="form-check-input me-2"
  //         type="checkbox"
  //         checked={multiSupportEnabled}
  //         id="multiSupportEnablePopup"
  //         onChange={(e) => setMultiSupportEnabled(e.target.checked)} />
  //       <label className="form-check-label" htmlFor="multiSupportEnablePopup">
  //         Multiple Support Enabled
  //       </label>
  //     </div>
  //   );
  // };

  const loadUnitsOfMeasure = () => {
    FormService.getUnitsOfMeasure(companyId)
      .then(res => {
        if (!res.data || res.data?.length === 0) return;

        const outputList = [], inputList = [];
        res.data?.forEach(element => {
          outputList.push({
            id: element.id,
            label: element.outputUnitName,
            value: element.outputUnit
          });
          inputList.push({
            id: element.id,
            label: element.inputUnitName,
            value: element.inputUnit
          });
        });
        const uniqueOutputArray = Array.from(new Set(outputList.map(obj => obj.value))).map(
          value => outputList.find(obj => obj.value === value)
        );
        uniqueOutputArray.sort((a, b) => a.value.localeCompare(b.value));
        const uniqueInputArray = Array.from(new Set(inputList.map(obj => obj.value))).map(
          value => inputList.find(obj => obj.value === value)
        );
        uniqueInputArray.sort((a, b) => a.value.localeCompare(b.value));
        setOutputUnits(uniqueOutputArray);
        setInputUnits(uniqueInputArray);
      })
      .catch((error) => {
      });
  };

  const getPossibleUOMsSelectorToRender = () => {
    return (
      <>
        <div className='Unit_Measure_selectbox'>
          <div className='row'>
            <div className='col-lg-6 p-2'>
              <label className="form-label mb-1">Possible UOMs</label>
              <Multiselect
                style={{ display: 'block' }}

                options={inputUnits}
                selectedValues={getSelectedUoms()}

                placeholder=''
                onSelect={(selectedList, selectedItem) => {
                  onSelectDeSelectUoms(selectedItem);
                }}
                onRemove={(selectedList, selectedItem) => {
                  onSelectDeSelectUoms(selectedItem);
                }}
                displayValue="label"
              />
            </div>
            <div className='col-lg-6 p-2'>
              <label className="form-label mb-1">Default UOM</label>
              <select className="form-select form-select-sm"
                onChange={(e) => setUOMData({ ...uomData, defaultUOM: e.target.value })}
                value={uomData.defaultUOM}>
                <option value="">Select</option>
                {uomData?.relevantUoms.map(u => (
                  <option value={u} key={u}>{inputUnits?.find(ip => ip.value === u)?.label ?? u}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </>
    );
  };

  const getSelectedUoms = () => {
    const data = [];
    uomData.relevantUoms?.forEach(uom => {
      const match = inputUnits.find(u => u.value === uom);
      if (!match) return;

      data.push(match);
    });
    return data;
  };

  const onSelectDeSelectUoms = (selectedItem) => {
    const uoms = [...uomData.relevantUoms];
    const index = uomData.relevantUoms?.indexOf(selectedItem.value);
    if (index >= 0) {
      uoms.splice(index, 1);
    } else {
      uoms.push(selectedItem.value);
    }
    setUOMData({
      ...uomData,
      relevantUoms: uoms
    });
  };

  const handleExternalDependency = (enabled) => {
    setExtDependency({
      enabled: enabled,
      value: enabled === true ? extDependency.value : null
    });
    if (!enabled) {
      setExtConfig(null);
    }
  };

  const renderExtDependencyCheckbox = () => {
    return (
      <div className='0'>
        <input className="form-check-input me-2"
          type="checkbox" id="externalDependencyCheckbox"
          checked={extDependency?.enabled}
          onChange={(e) => handleExternalDependency(e.target.checked)} />
        <label className="form-check-label" htmlFor="externalDependencyCheckbox">
          External Dependency
        </label>
      </div>
    );
  };

  const renderExtDependencySelector = () => {
    return (
      <>
        <div className='Unit_Measure_selectbox'>
          <div className='row'>
            <div className='col-lg-4 p-2'>
              <label className="form-label mb-1">Type</label>
              <select className="form-select form-select-sm"
                onChange={(e) => onExternalDependencyChange(e.target.value)}
                value={extDependency.value ?? ''}>
                <option value="">Select</option>
                <option value='EMISSION_CALCULATOR' key='EMISSION_CALCULATOR'>Emission Calculator</option>
              </select>
            </div>

            {
              extDependency.value === ExternalDependencyType.EMISSION_CALCULATOR &&
              <>
                <div className='col-lg-4 p-2'>
                  <label className="form-label mb-1">Scope</label>
                  <select className="form-select form-select-sm"
                    onChange={(e) => onScopeChange(e.target.value)}
                    value={extConfig?.emissionScope ?? ''}>
                    <option value="">Select</option>
                    <option value='Scope 1' key='Scope 1'>Scope 1</option>
                    <option value='Scope 2' key='Scope 2'>Scope 2</option>
                    <option value='Scope 3' key='Scope 3'>Scope 3</option>
                  </select>
                </div>
                <div className='col-lg-4 p-2'>
                  <label className="form-label mb-1">Category</label>
                  <select className="form-select form-select-sm"
                    onChange={(e) => setExtConfig({ ...extConfig, emissionCategory: e.target.value })}
                    value={extConfig?.emissionCategory ?? ''}>
                    <option value="">Select</option>
                    {
                      emissionCats?.map(cat => {
                        return <option value={cat.catgeory} key={`eCat-${cat.id}`}>{cat.category}</option>;
                      })
                    }
                  </select>
                </div>
              </>
            }
          </div>
        </div >
      </>
    );
  };


  const onExternalDependencyChange = (val) => {
    if (val === ExternalDependencyType.EMISSION_CALCULATOR) {

    }
    setExtDependency({ ...extDependency, value: val });
  };

  const onScopeChange = (val) => {
    setExtConfig({ emissionCategory: '', emissionScope: val });
    loadEmissionCats(val);
  };

  const loadEmissionCats = (scope) => {
    CarbonEmissionService.getCategories(scope).then(res => {
      if (res.status !== 200) return;

      setEmissionCats(res.data.data);
    }).catch(err => { });
  };

  const renderHelpTab = () => {
    return (
      <div className='PS_QusAdd_section 1'>
        <div className='ps_QusAdd pb-0'>
          <label className='mb-1'>Description</label>
          <ReactQuill value={helpText} onChange={(content) => setHelpText(content)}
            className='Description_quill mb-2' />
        </div>
      </div>
    )
  };

  const renderHistoricalDataCheckbox = () => {
    return (
      <div>
        <input className="form-check-input me-2"
          type="checkbox"
          checked={hisDataSupported}
          id="hisDataSupported"
          onChange={(e) => setHisDataSupported(e.target.checked)} />
        <label className="form-check-label " htmlFor="hisDataSupported">
          Support Historical Data
        </label>
      </div>
    );
  };

  const renderEditTab = () => {
    return (
      <div className='PS_QusAdd_section 1'>
        <div className='ps_QusAdd'>
          <label>Enter your question</label>
          <input className='form-control' type="text" value={field} onChange={(e) => setField(e.target.value)} />
        </div>
        <div className='ps_QusAdd_options'>
          {(selectedanswertype === 'RADIO' || selectedanswertype === 'MULTI_SELECT_DROP_DOWN' || selectedanswertype === 'DROP_DOWN' || selectedanswertype === 'MULTIPLE_CHOICE') && <div>
            <div className='SelectFields_list01'>
              {choiceoptions.map((itemchoice, choiceIndex) => (
                (!itemchoice.showOthers) && (
                  <>
                    <div className='SelectFields_list01_single mt-3' key={choiceIndex}>
                      <input type="text" name='name' value={itemchoice.name} className='form-control' onChange={updateFieldChanged(choiceIndex)} placeholder="Option name" />
                      <div className='SelectFields_list01_menu'>
                        <ul>
                          {scoreEnabled && <li>
                            <span className='ScoreBox'>Score</span>
                            <input type="number" name='score' value={itemchoice.score} className='form-control' onWheel={(e) => e.preventDefault()} onChange={updateFieldChanged(choiceIndex)} />
                          </li>}
                          <li>
                            <button className='btn btn-blank_outline' onClick={() => addChoice()}><BiPlusCircle /></button>
                          </li>
                          <li>
                            {(choiceIndex !== 0 || choiceoptions.length > 1) && <button className='btn btn-blank_outline' onClick={() => removeChoice(choiceIndex)}><BiTrash /></button>}
                          </li>
                        </ul>
                      </div>
                    </div>
                    {
                      showHelpTextForOption() &&
                      <div className=''>
                        <input type="text" name='helpText' value={itemchoice.helpText || ''} className='form-control mt-2' onChange={updateFieldChanged(choiceIndex)} placeholder="Help text (optional)" />
                      </div>
                    }
                  </>
                )
              ))}
              <input className="form-check-input me-2 mb-2" type="checkbox" checked={otherChecked} onChange={handleOtherChange} />
              <label className="form-check-label" htmlFor="Other">
                Add 'Other' option
              </label>
              {otherChecked && (
                choiceoptions.filter(x => x.showOthers === true).map((itemchoice, ind) => (
                  <div className='SelectFields_list01_single'>
                    <input type="text" name='name' className='form-control' placeholder='Other (Please specify)' value={itemchoice?.name} onChange={(e) => updateOtherChanged(e)} />
                    <div className='SelectFields_list01_menu'>
                      <ul>
                        <li>
                          <span className='ScoreBox'>Score</span>
                          <input type="number" name='score' className='form-control' value={itemchoice?.score} onWheel={(e) => e.preventDefault()} onChange={(e) => updateOtherChanged(e)} />
                        </li>
                      </ul>

                    </div>
                    <div className='d-flex'>
                      <input name="othersMandatory" className="form-check-input me-2" type="checkbox" checked={itemchoice?.othersMandatory} onChange={(e) => updateOtherChanged(e)} id="Required" />
                      <label className="form-check-label" htmlFor="Required">
                        Required
                      </label>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
          }
          {
            selectedanswertype === 'RADIO_GRID' && renderEditRadioButtonGridTab()
          }
        </div>
      </div>
    );
  };

  const renderEditRadioButtonGridTab = () => {
    return (
      <div>
        <button className="btn btn-link" onClick={addRowOrColumn}>
          <BiPlus /> Add Columns
        </button>
        {gridData.columns.length > 0 && (
          <div className='SelectFields_list01_RadioGrid p-3'>
            {gridData.columns.map((col, index) => (
              <div key={index} className='SelectFields_list01_single'>
                <input type="text" className={`form-control ${index === gridData.columns.length - 1 ? '' : 'mb-2'}`} value={col.name}
                  onChange={(e) => handleColumnChange(index, e.target.value)}
                  required />
                <div className='SelectFields_list01_menu'>
                  <ul>
                    <li>
                      <button className='btn btn-blank_outline' onClick={addRowOrColumn}><BiPlusCircle /></button>
                    </li>
                    <li>
                      <button className='btn btn-blank_outline' onClick={() => removeRowOrColumn(index)}><BiTrash /></button>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}
        <button className="btn btn-link" onClick={addRowSet} disabled={gridData.columns.length === 0}>
          <BiPlus /> Add Rows
        </button>
        {gridData.rowSets.map((set, setIndex) => (
          <div key={setIndex} className='SelectFields_list01_RadioGrid p-2 mb-2'>
            <div className="row m-0">
              <div className="col-lg-3 p-2">
                <label>Name</label>
                <input type="text" className='form-control' value={set.name}
                  onChange={(e) => handleRowSetChange(setIndex, 'name', e.target.value)}
                  required />
              </div>
              <div className="col-lg-3 p-2">
                <label>Code</label>
                <input type="text" className='form-control' value={set.code}
                  onChange={(e) => handleRowSetChange(setIndex, 'code', e.target.value)}
                  required />
              </div>
              <div className="col-lg-3 p-2">
                <label>Help Text</label>
                <input type="text" className='form-control' value={set.help}
                  onChange={(e) => handleRowSetChange(setIndex, 'help', e.target.value)}
                  required />
              </div>
              <div className="col-lg-2 p-2">
                <label>Sort Order</label>
                <input type="number" className='form-control' value={set.sortOrder} min="1"
                  onWheel={(e) => e.preventDefault()}
                  onChange={(e) => {
                    const value = Math.max(1, Number(e.target.value));
                    handleRowSetChange(setIndex, 'sortOrder', value)
                  }}
                  required />
              </div>
              <div className="col-lg-1 p-2">
                <button className='btn btn-blank_outline mt-2' onClick={() => removeRowSet(setIndex)}><BiTrash /></button>
              </div>
            </div>
            {set.rows.map((row, rowIndex) => (
              <div key={rowIndex} className='SelectFields_list01_single'>
                <div className="row m-0">
                  <div className="col-lg-6 p-2">
                    {rowIndex === 0 && <label>Option</label>}
                    <input type="text" className='form-control' value={row.option}
                      onChange={(e) => handleRowChange(setIndex, rowIndex, 'option', e.target.value)}
                      required />
                  </div>
                  <div className="col-lg-6 p-2">
                    {rowIndex === 0 && <label>Score</label>}
                    <input type="number" className='form-control' value={row.score} min="0"
                      onWheel={(e) => e.preventDefault()}
                      onChange={(e) => {
                        const value = Math.max(0, Number(e.target.value));
                        handleRowChange(setIndex, rowIndex, 'score', value)
                      }}
                      required />
                  </div>
                </div>
                <div className='SelectFields_list01_menu'>
                  <ul>
                    <li>
                      <button className='btn btn-blank_outline' onClick={addRowOrColumn}><BiPlusCircle /></button>
                    </li>
                    <li>
                      <button className='btn btn-blank_outline' onClick={() => removeRowOrColumn(rowIndex)}><BiTrash /></button>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }

  const renderAdvancedSettingsTab = () => {
    return (
      <div className='AdvancedSetting_card'>
        {isNumericValueQuestion() && (
          <>
            <div className='p-2'>
              {getUOMRequiredCheckboxToRender()}
              {uomRequired && getPossibleUOMsSelectorToRender()}
            </div>
            <div className='p-2'>
              {renderExtDependencyCheckbox()}
              {extDependency.enabled && renderExtDependencySelector()}
            </div>
            <div className='p-2'>
              {renderHistoricalDataCheckbox()}
            </div>
          </>
        )}
        <div className='p-2 d-flex'>
          {getFileUploadCheckboxToRender()}
          <div>
            {(allowFileUpload && (!optional)) && getFileRequiredCheckboxToRender()}
          </div>
        </div>
        <div className='p-2 d-flex'>
          {getCommentCheckboxToRender()}
          <div>
            {(allowComments && (!optional)) && getCommentRequiredCheckboxToRender()}
          </div>
        </div>
        {renderOptionSelectionValidation()}
      </div>
    );
  };

  const renderActionsTab = () => {
    return (
      <div>
        {
          actionsarray.map((itemchoice, actindex) => (
            <div className='PS_QusAdd_Options' key={actindex}>
              <div>If the answer is</div>
              <select className='form-select w-auto'
                value={itemchoice.formOption?.id}
                onChange={(e) => chooseOption(actindex, e.target.value)}>
                <option value="">Select</option>
                {choiceoptions.length > 0 && choiceoptions.map((opt, index) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.name}
                  </option>
                ))}
              </select>
              <div>
                <p>Actions to be taken</p>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="EMAIL" id='EMAIL'
                    checked={itemchoice.types && itemchoice.types.includes("EMAIL")}
                    onChange={(e) => actionTaken(e.target.checked, actindex, e.target.name)} />
                  <label className="form-check-label" htmlFor='EMAIL'>
                    Send email to
                  </label>
                  {itemchoice.types && itemchoice.types.includes("EMAIL") &&
                    <div>
                      <input type="text" className="form-control" placeholder='Type email addresses seperated using ","'
                        name='emailIds' onChange={(e) => emailUpdate(actindex, e.target.name, e.target.value)} />
                      <textarea className='form-control' rows="3" placeholder='Type email message'
                        value={itemchoice.emailMessage}
                        name='emailMessage' onChange={(e) => messageUpdate(actindex, e.target.name, e.target.value)} ></textarea>
                    </div>}
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="NOTIFICATION" id='NOTIFICATION'
                    checked={itemchoice.types && itemchoice.types.includes("NOTIFICATION")}
                    onChange={(e) => actionTaken(e.target.checked, actindex, e.target.name)} />
                  <label className="form-check-label" htmlFor='NOTIFICATION'>
                    Send notification in the system
                  </label>
                  {itemchoice.types && itemchoice.types.includes("NOTIFICATION") && <textarea className='form-control' rows="3" placeholder='Type notification message'
                    value={itemchoice.notification}
                    name='notification' onChange={(e) => messageUpdate(actindex, e.target.name, e.target.value)}></textarea>}
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="TASK" id='TASK'
                    checked={itemchoice.types && itemchoice.types.includes("TASK")}
                    onChange={(e) => actionTaken(e.target.checked, actindex, e.target.name)} />
                  <label className="form-check-label" htmlFor='TASK'>
                    Show alert in the dashboard
                  </label>
                  {itemchoice.types && itemchoice.types.includes("TASK") && <textarea className='form-control' rows="3" placeholder='Type alert message'
                    name='task' value={itemchoice.task}
                    onChange={(e) => messageUpdate(actindex, e.target.name, e.target.value)}></textarea>}
                </div>
              </div>
            </div>))
        }
        <button className='btn btn-primary px-4' onClick={() => addAction()}>Add another action</button>
      </div>
    )
  };

  const renderRemarksTab = (index) => {
    return (
      <div className='SelectFields_list01_single'>
        <div className='SelectFields_list01_menu'>
          <label className="form-check-label" htmlFor="remark">
            Include remark for
          </label>
          <div className="mb-2">
            <Multiselect
              options={choiceoptions}
              selectedValues={choiceoptions.filter(x => x.showRemarks === true)}
              onSelect={(selectedList, selectedItem) => {
                onSelectDeSelectML(selectedList, selectedItem, index)
              }}
              onRemove={(selectedList, selectedItem) => {
                onSelectDeSelectML(selectedList, selectedItem, index)
              }}
              displayValue="name"
            />
          </div>
          <label className="form-check-label" htmlFor="remarktitle">
            Remark title
          </label>
          <div className="mb-2">
            <input className='form-control' type="text" placeholder='Title' value={remarkTitle} onChange={(e) => setRemarkTitle(e.target.value)} />
          </div>
          <div className="mb-2">
            <input className="form-check-input me-2" type="checkbox" id="Required" checked={remarkRequired} onChange={(e) => handleRemarkRequired(e.target.checked)} />
            <label className="form-check-label" htmlFor="Requiredremark">
              Required
            </label>
          </div>
        </div>
      </div>
    )
  };

  const handleColumnChange = (index, value) => {
    setGridData(prev => {
      const newColumns = [...prev.columns];
      newColumns[index] = {
        ...newColumns[index],
        name: value
      };
      return { ...prev, columns: newColumns };
    });
  };


  const handleRowSetChange = (setIndex, field, value) => {
    setGridData(prev => {
      const newRowSets = [...prev.rowSets];
      newRowSets[setIndex][field] = value;
      return { ...prev, rowSets: newRowSets };
    });
  };

  const handleRowChange = (setIndex, rowIndex, field, value) => {
    setGridData(prev => {
      const newRowSets = [...prev.rowSets];
      newRowSets[setIndex].rows[rowIndex][field] = value;
      return { ...prev, rowSets: newRowSets };
    });
  };

  const addRowOrColumn = () => {
    setGridData(prev => {
      const newColumns = [...prev.columns, ''];
      const newRowSets = prev.rowSets.map(set => ({
        ...set,
        rows: [...set.rows, { option: '', score: '' }]
      }));
      return { columns: newColumns, rowSets: newRowSets };
    });
  };

  const removeRowOrColumn = (index) => {
    setGridData(prev => {
      const newColumns = prev.columns.filter((_, i) => i !== index);
      const newRowSets = prev.rowSets.map(set => ({
        ...set,
        rows: set.rows.filter((_, i) => i !== index)
      }));
      return newColumns.length === 0 ? { columns: [], rowSets: [] } : { columns: newColumns, rowSets: newRowSets };
    });
  };

  const addRowSet = () => {
    setGridData(prev => ({
      ...prev,
      rowSets: [...prev.rowSets, {
        name: '', code: '', help: '', sortOrder: '',
        rows: prev.columns.map(() => ({ option: '', score: '' }))
      }]
    }));
  };

  const removeRowSet = (setIndex) => {
    setGridData(prev => {
      const newRowSets = prev.rowSets.filter((_, i) => i !== setIndex);
      return newRowSets.length === 0 ? { columns: [], rowSets: [] } : { ...prev, rowSets: newRowSets };
    });
  };

  const constructGridConfigPayload = () => {
    const gridConfig = {
      rows: gridData.rowSets.map((set, setIndex) => ({
        id: set.id || null,
        name: set.name,
        helpText: set.help,
        sortOrder: set.sortOrder,
        active: true,
        code: set.code,
        cellOptions: set.rows.map((row, rowIndex) => ({
          id: row.id || null,
          name: row.option,
          score: row.score,
          sortOrder: row.sortOrder ? row.sortOrder : rowIndex + 1,
          valueCode: set.code,
          columnRef: `col-${rowIndex + 1}`
        }))
      })),
      columns: gridData.columns.map((col, colIndex) => ({
        id: col.id || null,
        name: col.name,
        ref: `col-${colIndex + 1}`,
        sortOrder: col.sortOrder ? col.sortOrder : colIndex + 1,
        active: true
      }))
    };
    return gridConfig;
  };

  const renderRadioButtonGridTab = () => {
    return (
      <div>
        <button className="btn btn-link" onClick={addRowOrColumn}>
          <BiPlus /> Add Columns
        </button>
        {gridData.columns.length > 0 && (
          <div className='SelectFields_list01_RadioGrid p-3'>
            {gridData.columns.map((col, index) => (
              <div key={index} className='SelectFields_list01_single'>
                <input type="text" className={`form-control ${index === gridData.columns.length - 1 ? '' : 'mb-2'}`} value={col.name}
                  onChange={(e) => handleColumnChange(index, e.target.value)}
                  required />
                <div className='SelectFields_list01_menu'>
                  <ul>
                    <li>
                      <button className='btn btn-blank_outline' onClick={addRowOrColumn}><BiPlusCircle /></button>
                    </li>
                    <li>
                      <button className='btn btn-blank_outline' onClick={() => removeRowOrColumn(index)}><BiTrash /></button>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}
        <button className="btn btn-link" onClick={addRowSet} disabled={gridData.columns.length === 0}>
          <BiPlus /> Add Rows
        </button>
        {gridData.rowSets.map((set, setIndex) => (
          <div key={setIndex} className='SelectFields_list01_RadioGrid  p-2 mb-2'>
            <div className="row m-0">
              <div className="col-lg-3 p-2">
                <label>Name</label>
                <input type="text" className='form-control' value={set.name}
                  onChange={(e) => handleRowSetChange(setIndex, 'name', e.target.value)}
                  required />
              </div>
              <div className="col-lg-3 p-2">
                <label>Code</label>
                <input type="text" className='form-control' value={set.code}
                  onChange={(e) => handleRowSetChange(setIndex, 'code', e.target.value)}
                  required />
              </div>
              <div className="col-lg-3 p-2">
                <label>Help Text</label>
                <input type="text" className='form-control' value={set.help}
                  onChange={(e) => handleRowSetChange(setIndex, 'help', e.target.value)}
                  required />
              </div>
              <div className="col-lg-2 p-2">
                <label>Sort Order</label>
                <input type="number" className='form-control' value={set.sortOrder} min="1"
                  onWheel={(e) => e.preventDefault()}
                  onChange={(e) => {
                    const value = Math.max(1, Number(e.target.value));
                    handleRowSetChange(setIndex, 'sortOrder', value)
                  }}
                  required />
              </div>
              <div className="col-lg-1 p-2">
                <button className='btn btn-blank_outline mt-2' onClick={() => removeRowSet(setIndex)}><BiTrash /></button>
              </div>
            </div>
            {set.rows.map((row, rowIndex) => (
              <div key={rowIndex} className='SelectFields_list01_single'>
                <div className="row m-0">
                  <div className="col-lg-6 p-2">
                    {rowIndex === 0 && <label>Option</label>}
                    <input type="text" className='form-control' value={row.option}
                      onChange={(e) => handleRowChange(setIndex, rowIndex, 'option', e.target.value)}
                      required />
                  </div>
                  <div className="col-lg-6 p-2">
                    {rowIndex === 0 && <label>Score</label>}
                    <input type="number" className='form-control' value={row.score} min="0"
                      onWheel={(e) => e.preventDefault()}
                      onChange={(e) => {
                        const value = Math.max(0, Number(e.target.value));
                        handleRowChange(setIndex, rowIndex, 'score', value)
                      }}
                      required />
                  </div>
                </div>
                <div className='SelectFields_list01_menu'>
                  <ul>
                    <li>
                      <button className='btn btn-blank_outline' onClick={addRowOrColumn}><BiPlusCircle /></button>
                    </li>
                    <li>
                      <button className='btn btn-blank_outline' onClick={() => removeRowOrColumn(rowIndex)}><BiTrash /></button>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }

  const renderEditTabForNewQuestion = () => {
    return (
      <>
        <div className='ps_QusAdd'>
          <label>Enter your question</label>
          <input className='form-control' type="text" value={field} onChange={(e) => setField(e.target.value)} />
        </div>
        <div className='ps_QusAdd pb-0'>
          <label>Help Text</label>
          <ReactQuill value={helpText} onChange={(content) => setHelpText(content)} className='Description_quill mb-2' />
        </div>
        <div className='ps_QusAdd_options'>
          {(selectedanswertype === 'RADIO' || selectedanswertype === 'MULTI_SELECT_DROP_DOWN' || selectedanswertype === 'DROP_DOWN' || selectedanswertype === 'MULTIPLE_CHOICE') && <div>
            <div className={scoreEnabled ? 'SelectFields_list01 mt-4' : 'SelectFields_list01'}>
              {choiceoptions.map((itemchoice, choiceIndex) => (
                (!itemchoice.showOthers) && (
                  <>
                    <div className='SelectFields_list01_single mt-3' key={choiceIndex}>
                      <input type="text" name='name' value={itemchoice.name} className='form-control' onChange={updateFieldChanged(choiceIndex)} placeholder="Option name" />
                      <div className='SelectFields_list01_menu'>
                        <ul key={choiceIndex}>
                          {scoreEnabled && <li>
                            <span className='ScoreBox'>Score</span>
                            <input type="number" name='score' value={itemchoice.score} className='form-control' onWheel={(e) => e.preventDefault()} onChange={updateFieldChanged(choiceIndex)} />
                          </li>}
                          <li>
                            <button className='btn btn-blank_outline' onClick={() => addChoice()}><BiPlusCircle /></button>
                          </li>
                          <li>
                            {(choiceIndex !== 0 || choiceoptions.length > 1) && <button className='btn btn-blank_outline' onClick={() => removeChoice(choiceIndex)}><BiTrash /></button>}
                          </li>
                        </ul>
                      </div>
                    </div>
                    {
                      showHelpTextForOption() &&
                      <input type="text" name='helpText' value={itemchoice.helpText || ''} className='form-control mt-2' onChange={updateFieldChanged(choiceIndex)} placeholder="Help text (optional)" />
                    }
                  </>
                )
              ))}
              <input className="form-check-input me-2 mb-2" type="checkbox" id="Score" onChange={handleOtherChange} />
              <label className="form-check-label" htmlFor="Score">
                Add 'Other' option
              </label>
              {otherChecked && (
                choiceoptions.filter(x => x.showOthers === true).map((itemchoice, ind) => (
                  <div className='SelectFields_list01_single'>
                    <input type="text" name='name' className='form-control' placeholder='Other (Please specify)' value={itemchoice?.name} onChange={(e) => updateOtherChanged(e)} />
                    <div className='SelectFields_list01_menu'>
                      <ul>

                        <li>
                          <span className='ScoreBox'>Score</span>
                          <input type="number" name='score' className='form-control' value={itemchoice?.score} onWheel={(e) => e.preventDefault()} onChange={(e) => updateOtherChanged(e)} />
                        </li>

                      </ul>
                    </div>

                    <div className='d-flex'>
                      <input name="othersMandatory" className="form-check-input me-1" type="checkbox" checked={itemchoice?.othersMandatory} onChange={(e) => updateOtherChanged(e)} id="Required" />
                      <label className="form-check-label" htmlFor="Required">
                        Required
                      </label>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
          }
          {selectedanswertype === 'DATE_TIME_BOX' && <div className='mb-2'>
            <input type="date" className='form-control' placeholder='Single line text' />
          </div>
          }
          {selectedanswertype === 'DATE_RANGE' && <div>
            <div className='mb-2'>
              <input type="date" className='form-control' placeholder='Date 1' />
            </div>
            <input type="date" className='form-control' placeholder='Date 2' />
          </div>
          }
          {selectedanswertype === 'RADIO_GRID' && renderRadioButtonGridTab()}
        </div>
      </>
    );
  };

  const isOptionsBasedAnswer = () => {
    return selectedanswertype === QuestionType.MULTI_SELECT_DROP_DOWN
      || selectedanswertype === QuestionType.DROP_DOWN
      || selectedanswertype === QuestionType.RADIO
      || selectedanswertype === QuestionType.MULTIPLE_CHOICE
      || selectedanswertype === QuestionType.RADIO_GRID;
  };

  const showHelpTextForOption = () => {
    return selectedanswertype === QuestionType.RADIO
      || selectedanswertype === QuestionType.MULTIPLE_CHOICE;
  };

  const renderOptionHelpText = (opt) => {
    if (!opt.helpText) return null;
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Popover id={`popover-help-${opt.id}`} className="p-2">
            <div className="p-1">{opt.helpText}</div>
          </Popover>
        }>
        <span className="ms-2 cursor-pointer">
          <BsQuestionCircle />
        </span>
      </OverlayTrigger>
    );
  };

  const renderOptionSelectionValidation = () => {
    if (selectedanswertype !== QuestionType.MULTIPLE_CHOICE) {
      return <></>;
    }

    return (
      <div className='p-2'>
        <div className='d-flex align-items-center gap-2 flex-wrap'>
          <h6>Select total options:</h6>
          <select
            className="form-select form-select-sm w-auto"
            value={optionSelectionValidation.operator || ''}
            onChange={(e) => setOptionSelectionValidation({
              ...optionSelectionValidation,
              operator: e.target.value || null,
              maximumCount: e.target.value === FormOptionValidationOperator.BETWEEN ? optionSelectionValidation.maximumCount : null
            })}
          >
            <option value="">Select operator</option>
            <option value={FormOptionValidationOperator.EQUAL_TO}>Equal to</option>
            <option value={FormOptionValidationOperator.AT_LEAST}>At least</option>
            <option value={FormOptionValidationOperator.AT_MOST}>At most</option>
            <option value={FormOptionValidationOperator.BETWEEN}>Between</option>
          </select>
          <input
            type="number"
            className="form-control form-control-sm w-auto"
            style={{ maxWidth: '100px' }}
            placeholder="Count"
            value={optionSelectionValidation.count || ''}
            onWheel={(e) => e.preventDefault()}
            onChange={(e) => setOptionSelectionValidation({
              ...optionSelectionValidation,
              count: e.target.value ? parseInt(e.target.value) : null
            })}
            min="1"
          />
          {optionSelectionValidation.operator === FormOptionValidationOperator.BETWEEN && (
            <input
              type="number"
              className="form-control form-control-sm w-auto"
              style={{ maxWidth: '100px' }}
              placeholder="Max"
              value={optionSelectionValidation.maximumCount || ''}
              onWheel={(e) => e.preventDefault()}
              onChange={(e) => setOptionSelectionValidation({
                ...optionSelectionValidation,
                maximumCount: e.target.value ? parseInt(e.target.value) : null
              })}
              min="1"
            />
          )}
        </div>
        {optionSelectionValidation.operator && (
          <div className='mt-2'>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Validation message (optional)"
              value={optionSelectionValidation.validationMessage || ''}
              onChange={(e) => setOptionSelectionValidation({
                ...optionSelectionValidation,
                validationMessage: e.target.value || null
              })}
            />
          </div>
        )}
      </div>
    );
  };

  const canShowScoreCheckbox = () => {
    return selectedanswertype === 'RADIO' 
      || selectedanswertype === 'MULTI_SELECT_DROP_DOWN' 
      || selectedanswertype === 'DROP_DOWN' 
      || selectedanswertype === 'MULTIPLE_CHOICE' 
      || selectedanswertype === 'RADIO_GRID'
      || selectedanswertype === 'FILE_UPLOAD';
  };

  return (
    <div className="FormMainBody">
      <FormHeader key="buildFormKey" header={formdata.name} showWizard={true} formData={formdata} />
      <div className='FormMainBody_main'>
        <FormSidebar key="formSidebarKey"
          isBuildMode={true}
          name={formdata.name}
          fields={formdata.fields}
          sections={formdata.sections}
          currentSection={currentsection}
          onRootFieldClickCallback={(fieldId) => getFieldWithoutSection(fieldId)}
          onSectionClickCallback={(sectionId) => {
            setIsSubsection(false);
            getSectionDetails(sectionId, null, submitlanguage);
          }}
          onSubsectionClickCallback={(subSectionId, subSections) => {
            setIsSubsection(true);
            getSectionDetails(subSectionId, null, submitlanguage);
          }}
          onFieldDropComplete={(droppedField, droppedOver, sectionId) => {
            handleFieldDrop(droppedField, droppedOver, sectionId);
          }}
          onSectionDropComplete={(droppedSection, droppedOver, sectionId) => {
            handleSectionDrop(droppedSection, droppedOver, sectionId);
          }} />
        <div className='FormMainBody_SectionBox'>
          <div className='FormMainBody_SectionBox_inner01'>
            <section className='FB_Section_card'>
              <div className='FBS_head_section 1'>
                <div className='py-2 d-flex justify-content-end' >
                  <select
                    className="form-select form-select-sm w-auto"
                    required
                    onChange={(e) => {
                      setSubmitLanguage(e.target.value);
                      getFormDetails({ fetchFor: "INITIAL", lang: e.target.value });
                    }}
                    value={submitlanguage}>
                    <option value="">Select</option>
                    {languages.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className='FBS_head_section_inner d-flex  justify-content-center'>
                  <div className='d-flex flex-column align-items-center me-2'>
                    <h4 className='m-0'>{formdata.name}</h4>
                    {formdata.description && <p className='m-0 mt-1'>{formdata.description}</p>}
                  </div>
                  {formdata !== '' && <OverlayTrigger placement="top" overlay={Utils.renderTooltip('Edit Form')}>
                    <Button size="sm" variant="outline-primary" className='icon_btn'>
                      <Icons.BiPencil className='edit-icon' onClick={() => setUpdateForm(true)} />
                    </Button>
                  </OverlayTrigger>}
                  {(updateform) && (
                    <FormCreate
                      isRename={updateform}
                      form={formdata}
                      callbackFn={callbackFn}
                    />
                  )}
                </div>
              </div>
              <div className='FB_Section_body'>
                {/* <div className='FBS_head d-flex align-items-center'>
              </div> */}
                <div className='FBS_body Section_ViewBox'>
                  <section className='Page_section_01'>
                    {formsectionsdata && formsectionsdata.sectionAvailable && <div className="Page_section_01_head d-flex align-items-center">
                      <h6 className='m-0 me-2'>{formsectionsdata.title}</h6>
                      {formsectionsdata !== '' && !isSubsection && <OverlayTrigger placement="top" overlay={Utils.renderTooltip('Edit Section')}>
                        <Button variant="outline-primary" size="sm" className='icon_btn'><Icons.BiPencil className='edit-icon' onClick={() => editSection(formsectionsdata.id)} /></Button>
                      </OverlayTrigger>}
                      {formsectionsdata !== '' && isSubsection && <OverlayTrigger placement="top" overlay={Utils.renderTooltip('Edit SubSection')}>
                        <Button variant="outline-primary" size="sm" className='icon_btn'><Icons.BiPencil className='edit-icon' onClick={() => editSubSection(formdata.id, formsectionsdata.id)} /></Button>
                      </OverlayTrigger>}
                      {formsectionsdata !== '' && <OverlayTrigger placement="top" overlay={Utils.renderTooltip('Delete Section')}>
                        <Button variant="outline-primary" size="sm" className='icon_btn'><Icons.BiTrash className='delete-icon' onClick={() => deleteSection(formsectionsdata.id)} /></Button>
                      </OverlayTrigger>}
                    </div>}
                    <div className='Page_section_01_body'>
                      {formsectionsdata !== '' && formsectionsdata.fields.map((item, index) => (
                        <div className='PS_inner_01' key={index}>
                          {(showquestionedit && fieldeditid === item.id)
                            ? <div className='PS_inner_Qus_Card'>
                              <div className='PS_inner_Qus_Card_In'>
                                <div className='PS_Qus_Card_head'>
                                  <div className='PS_Qus_Card_Tab 1'>
                                    <ul>
                                      <li className={`${(tabchoosed === 'edit') ? "active" : ""}`}>
                                        <a href='javascript:void(0);' onClick={() => setTabChoosed('edit')}>Edit</a>
                                      </li>
                                      <li className={`${(tabchoosed === 'logic') ? "active" : ""}`}>
                                        <a href='javascript:void(0);' onClick={() => setTabChoosed('logic')}>Smart Rules</a>
                                      </li>
                                      <li className={`${(tabchoosed === 'AdvancedSetting') ? "active" : ""}`}>
                                        <a href='javascript:void(0);' onClick={() => setTabChoosed('AdvancedSetting')}>Advanced Settings</a>
                                      </li>
                                      <li className={`${(tabchoosed === 'help') ? "active" : ""}`}>
                                        <a href='javascript:void(0);' onClick={() => setTabChoosed('help')}>Help</a>
                                      </li>
                                      {isActionNeeded() && <li className={`${(tabchoosed === 'actions') ? "active" : ""}`}>
                                        <a href='javascript:void(0);' onClick={() => {
                                          getActionDetails();
                                          setTabChoosed('actions')
                                        }}>Actions</a>
                                      </li>}
                                      {isRemarkNeeded() && <li className={`${(tabchoosed === 'remarks') ? "active" : ""}`}>
                                        <a href='javascript:void(0);' onClick={() => {
                                          setTabChoosed('remarks')
                                        }}>Remarks</a>
                                      </li>}
                                    </ul>
                                  </div>
                                  <div className='PS_Qus_Card_Select 1'>
                                    <ul>
                                      {canShowScoreCheckbox() && <li>
                                        <input className="form-check-input me-2" type="checkbox" id="Score" checked={scoreEnabled} onChange={(e) => handleScoreEnable(e.target.checked)} />
                                        <label className="form-check-label" htmlFor="Score">
                                          Score
                                        </label>
                                      </li>}

                                      <li>
                                        <input className="form-check-input me-2" type="checkbox" checked={!optional} id="Required" onChange={(e) => handleRequired(e.target.checked)} />
                                        <label className="form-check-label" htmlFor="Required">
                                          Required
                                        </label>
                                      </li>
                                      <li>
                                        <Dropdown onSelect={(e) => {
                                          setSelectedAnsType(e);
                                          setHisDataSupported(e === 'NUMERIC_VALUE');
                                        }}>
                                          <Dropdown.Toggle variant="light" id="dropdown-basic" className='Select_Field'>
                                            {FORMCONTROLLERSTYPE.filter(x => x.key === selectedanswertype).map((filtered, filteredindex) => (
                                              <div className='d-flex align-items-center' key={filteredindex}>
                                                <Icon iconName={filtered.icon} />
                                                {filtered.name}
                                              </div>
                                            ))}
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu>
                                            {FORMCONTROLLERSTYPE.map(item => (
                                              <Dropdown.Item eventKey={item.key} className="Select_Field_Drop" key={item.key}>
                                                <Icon iconName={item.icon} />
                                                {item.name}</Dropdown.Item>
                                            ))}
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <div className={tabchoosed === 'logic' ? '' : 'PS_Qus_Card_body'}>
                                  {tabchoosed === 'edit' && renderEditTab()}
                                  {
                                    tabchoosed === 'logic' &&
                                    <QuestionLogicForm
                                      key="qLogicForm"
                                      formData={{
                                        id: id,
                                        fieldId: fieldeditid,
                                        sectionId: currentsection,
                                        options: choiceoptions,
                                        sections: formdata.sections,
                                        questions: formsectionsdata.fields
                                      }}
                                      cancelCallback={() => resetFieldProperties()} />
                                  }
                                  {tabchoosed === 'AdvancedSetting' && renderAdvancedSettingsTab()}
                                  {tabchoosed === 'help' && renderHelpTab()}
                                  {tabchoosed === 'actions' && renderActionsTab()}
                                  {tabchoosed === 'remarks' && renderRemarksTab(index)}
                                </div>
                                {
                                  tabchoosed !== 'logic' &&
                                  <div className='PS_Qus_Card_footer'>
                                    {/* <button className='btn btn-primary'><BiPlus /> Next Questions</button> */}
                                    {(tabchoosed === 'actions')
                                      ? <div>
                                        <button className='btn btn-secondary px-3 me-2' onClick={() => resetFieldProperties()}>Cancel</button>
                                        <button className='btn btn-primary px-4 sbmBtn' onClick={() => handleSaveActions()}>Save</button>
                                      </div>
                                      : <div>
                                        <button className='btn btn-secondary px-3 me-2' onClick={() => resetFieldProperties()}>Cancel</button>
                                        <button className='btn btn-primary px-4 sbmBtn' onClick={() => handleSaveField(true)}>Save</button>
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                            : <div className='PS_inner_Qus_ViewCard02'>
                              <div className='PSS_Qus_ViewCard02'>
                                <div className='PSinner_Qus_View_box02'>
                                  <h6>
                                    <span className='me-1'> {index + 1}.</span>
                                    {item.name}
                                  </h6>
                                  {
                                    item.type !== 'EXTERNAL' &&
                                    <div className='PSinner_Qus_View_menu 1'>
                                      <ul>
                                        <li>
                                          <button className='btn btn-secondary btn-sm' onClick={() => editField(item)}>Edit</button>
                                        </li>
                                        <li>
                                          <button className='btn btn-secondary btn-sm' onClick={() => deleteField(item)}>Delete</button>
                                        </li>
                                      </ul>
                                    </div>
                                  }
                                </div>
                                <div className='PSinner_Option_View_box02 1'>
                                  {item.type === 'RADIO' && <div >
                                    {item.options.length > 0 && item.options.map((opt, radoptindex) => (
                                      <div className="form-check" key={radoptindex}>
                                        <input className="form-check-input" type="radio" name="radopt" id={opt.id} disabled />
                                        <label className="form-check-label" htmlFor={opt.id}>
                                          {opt.name}
                                          {renderOptionHelpText(opt)}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                  }
                                  {item.type === 'RADIO_GRID' &&
                                    <GridTable
                                      type='BUILD'
                                      content={item}
                                    />
                                  }
                                  {item.type === 'MULTI_SELECT_DROP_DOWN' && <div>
                                    <select className='form-select w-auto'>
                                      {item.options.length > 0 && item.options.map((opt) => (
                                        <option key={opt.id} value={opt.name}>
                                          {opt.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  }
                                  {item.type === 'MULTIPLE_CHOICE' && <div>
                                    {item.options.length > 0 && item.options.map((opt, checkoptindex) => (
                                      <div className="form-check" key={checkoptindex}>
                                        <input className="form-check-input" type="checkbox" name="radopt" id={opt.id} disabled />
                                        <label className="form-check-label" htmlFor={opt.id}>
                                          {opt.name}
                                          {renderOptionHelpText(opt)}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                  }
                                  {item.type === 'DROP_DOWN' && <div>
                                    <select className='form-select w-auto'>
                                      {item.options.length > 0 && item.options.map((opt) => (
                                        <option key={opt.id} value={opt.name}>
                                          {opt.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  }
                                  {item.type === 'RATING' && <div>
                                    <select className='form-select w-auto'>
                                      <option>1</option>
                                      <option>2</option>
                                      <option>3</option>
                                    </select>
                                  </div>
                                  }
                                  {item.type === 'NUMERIC_VALUE' && <div>
                                    <input type="number" className="form-control" readOnly />
                                  </div>
                                  }
                                  {item.type === 'SINGLE_TEXTBOX' && <div>
                                    <input type="text" className="form-control" readOnly />
                                  </div>
                                  }
                                  {item.type === 'DATE_TIME_BOX' && <div>

                                    <input type="date" className='form-control w-auto' disabled />
                                  </div>
                                  }
                                  {item.type === 'DATE_RANGE' && <div>
                                    <div className="m-0 d-flex">
                                      <div className='p-1'> <input type="date" className='form-control w-auto' disabled /></div>
                                      <div className='p-1'><input type="date" className='form-control w-auto' disabled /></div>
                                    </div>
                                  </div>
                                  }
                                  {item.type === 'TEXT_BOX' && <div>
                                    <textarea className='form-control' rows="5" placeholder='Paragraph' readOnly></textarea>
                                  </div>
                                  }
                                  {item.type === 'FILE_UPLOAD' && <div>
                                    <input type="File" className='form-control' placeholder='Single line text' disabled />
                                  </div>
                                  }
                                  {item.type === 'SLIDER' && <div>
                                    <select className='form-select w-auto'>
                                      <option>Agricultural</option>
                                      <option>manufacturing</option>
                                      <option>Agricultural</option>
                                    </select>
                                  </div>
                                  }
                                  {item.type === 'SEARCH_BOX' && <div>
                                    <select className='form-select w-auto'>
                                      <option>Agricultural</option>
                                      <option>manufacturing</option>
                                      <option>Agricultural</option>
                                    </select>
                                  </div>
                                  }
                                  {item.type === 'EMAIL' && <div>
                                    <select className='form-select w-auto'>
                                      <option>Agricultural</option>
                                      <option>manufacturing</option>
                                      <option>Agricultural</option>
                                    </select>
                                  </div>
                                  }
                                  {item.type === 'YES_NO' && <div>
                                    <select className='form-select w-auto'>
                                      <option>Agricultural</option>
                                      <option>manufacturing</option>
                                      <option>Agricultural</option>
                                    </select>
                                  </div>
                                  }
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      ))}
                      <div className='PS_inner_01'>
                        {!showquestion
                          ? <span></span>
                          : <div className='PS_inner_Qus_Card'>
                            <div className='PS_inner_Qus_Card_In'>
                              <div className='PS_Qus_Card_head'>
                                <div className='PS_Qus_Card_Tab 2'>
                                  <ul>
                                    <li className={`${tabchoosed === 'edit' ? 'active' : ''}`}>
                                      <a href='javascript:void(0);' onClick={() => setTabChoosed('edit')}>Edit</a>
                                    </li>
                                    <li className={`${tabchoosed === 'AdvancedSetting' ? 'active' : ''}`}>
                                      <a href='javascript:void(0);' onClick={() => setTabChoosed('AdvancedSetting')}>Advanced Settings</a>
                                    </li>
                                  </ul>
                                </div>
                                <div className='PS_Qus_Card_Select 2'>
                                  <ul>
                                    {canShowScoreCheckbox() && (
                                      <li>
                                        <input className="form-check-input me-2" type="checkbox" id="Score" checked={scoreEnabled} onChange={(e) => handleScoreEnable(e.target.checked)} />
                                        <label className="form-check-label" htmlFor="Score">
                                          Score
                                        </label>
                                      </li>
                                    )}
                                    <li>
                                      <input className="form-check-input me-2" type="checkbox" id="Required" checked={!optional} onChange={(e) => handleRequired(e.target.checked)} />
                                      <label className="form-check-label" htmlFor="Required">
                                        Required
                                      </label>
                                    </li>
                                    <li>
                                      <Dropdown onSelect={(e) => {
                                        setSelectedAnsType(e);
                                        setHisDataSupported(e === 'NUMERIC_VALUE');
                                      }}>
                                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='Select_Field'>
                                          {FORMCONTROLLERSTYPE.filter(x => x.key === selectedanswertype).map((filtered, filteredindex) => (
                                            <div className='d-flex align-items-center' key={filteredindex}>
                                              <Icon iconName={filtered.icon} />
                                              {filtered.name}
                                            </div>
                                          ))}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                          {FORMCONTROLLERSTYPE.map(item => (
                                            <Dropdown.Item eventKey={item.key} className="Select_Field_Drop" key={item.key}>
                                              <Icon iconName={item.icon} />
                                              {item.name}</Dropdown.Item>
                                          ))}
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className='PS_Qus_Card_body'>
                                <div className='PS_QusAdd_section 2'>
                                  {tabchoosed == 'edit' && renderEditTabForNewQuestion()}
                                  {tabchoosed === 'AdvancedSetting' && renderAdvancedSettingsTab()}
                                </div>
                                <div className='PS_QusAdd_Options'></div>
                              </div>
                              <div className='PS_Qus_Card_footer'>
                                <div>
                                  <button className='btn btn-secondary px-3 me-2' onClick={() => resetFieldProperties()}>Cancel</button>
                                  <button className='btn btn-primary px-4 sbmBtn' onClick={() => handleSaveField(false)}>Save</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        <div>
                          {!showanswertype
                            ? <span></span>
                            : <div className='ChooseAnswerType_Section'>
                              <div className='ChooseAnswerType_Section_in'>
                                <div>
                                  <h6>Choose answer type</h6>
                                  <div style={{ float: 'right' }}>
                                    <button className='btn btn-secondary' onClick={() => {
                                      setShowAnswerType(false);
                                      resetFieldProperties();
                                    }}>Cancel</button>
                                  </div>
                                </div>
                                <div>
                                  <div className='mb-2'>
                                    <div className='pb-1'>Common fields
                                    </div>
                                    <div className='All_fields_chosseBox'>
                                      <ul>
                                        <li onClick={() => chooseAnswerType('SINGLE_TEXTBOX')}>
                                          <div className='fields_Box_01'>
                                            <BiText /> Single line text
                                          </div>
                                        </li>
                                        <li onClick={() => chooseAnswerType('NUMERIC_VALUE')}>
                                          <div className='fields_Box_01'>
                                            <Icons.BiHash /> Numeric field
                                          </div>
                                        </li>
                                        <li onClick={() => chooseAnswerType('TEXT_BOX')}>
                                          <div className='fields_Box_01'>
                                            <BiParagraph /> Paragraph
                                          </div>
                                        </li>
                                        <li onClick={() => chooseAnswerType('DROP_DOWN')}>
                                          <div className='fields_Box_01'>
                                            <BiListUl /> Single select field
                                          </div>
                                        </li>
                                        <li onClick={() => chooseAnswerType('MULTI_SELECT_DROP_DOWN')}>
                                          <div className='fields_Box_01'>
                                            <BiListCheck /> Multi select field
                                          </div>
                                        </li>
                                        <li onClick={() => chooseAnswerType('RADIO')}>
                                          <div className='fields_Box_01'>
                                            <BiRadioCircleMarked /> Radio button
                                          </div>
                                        </li>
                                        <li onClick={() => chooseAnswerType('RADIO_GRID')}>
                                          <div className='fields_Box_01'>
                                            <BiRadioCircleMarked /> Radio button grid
                                          </div>
                                        </li>
                                        <li onClick={() => chooseAnswerType('MULTIPLE_CHOICE')}>
                                          <div className='fields_Box_01'>
                                            <BiCheckSquare /> Check box
                                          </div>
                                        </li>
                                        <li onClick={() => chooseAnswerType('DATE_TIME_BOX')}>
                                          <div className='fields_Box_01'>
                                            <BiCalendarAlt /> Date Picker
                                          </div>
                                        </li>
                                        <li onClick={() => chooseAnswerType('DATE_RANGE')}>
                                          <div className='fields_Box_01'>
                                            <BiCalendar /> Date Range Picker
                                          </div>
                                        </li>
                                        <li onClick={() => chooseAnswerType('FILE_UPLOAD')}>
                                          <div className='fields_Box_01'>
                                            <BiUpload /> File upload
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      {formdata !== '' && formdata.sections.length > 0 && formsectionsdata.sectionAvailable && <div className='Add_Data_btnbox'>
                        <button
                          className="btn btn-link"
                          onClick={() => {
                            resetFieldProperties();
                            handleQuestionShow(true);
                          }}>
                          {" "}
                          <BiPlus /> New Question
                        </button>
                      </div>
                      }
                    </div>
                  </section>
                  <div className='py-2 px-3'>
                    <Dropdown>
                      <Dropdown.Toggle variant="primary" id="dropdown-basic">
                        <BiPlus /> New
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => {
                          resetFieldProperties();
                          handleQuestionShow(false)
                        }}>Question</Dropdown.Item>
                        <Dropdown.Item onClick={handleShow} >Section</Dropdown.Item>
                        {!isSubsection && <Dropdown.Item onClick={() => {
                          handleShowSubSection(formdata.id);
                        }}>Subsection</Dropdown.Item>}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered>
        {editEnable ? (
          <Modal.Header closeButton className="pb-2">
            <Modal.Title className="h5">
              {actionType === 1 ? "Edit Section" : "Edit SubSection"}{" "}
            </Modal.Title>
          </Modal.Header>
        ) : (
          <Modal.Header closeButton className="pb-2">
            <Modal.Title className="h5">
              {actionType === 1 ? "Create new Section" : "Create new SubSection"}{" "}
            </Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={handleCreateSectionForm}>
            <div className="mb-2">
              <label htmlFor="" className="form-label mb-1">
                {actionType === 1 ? "Section Title" : "Subsection Title"}
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                id="sectiontxt"
                required
                onChange={(e) => setSectionName(e.target.value)}
                value={sectionname}
              />
            </div>
            {actionType === 2 && (
              <div className="mb-2">
                <label htmlFor="parentsection" className="form-label mb-1">
                  Section
                </label>
                <select
                  className="form-select w-100 form-select-sm"
                  required
                  id="parentSection"
                  value={selParentSection}
                  onChange={(e) => setSelParentSection(e.target.value)}
                >
                  <option value="" disabled hidden>
                    Select
                  </option>
                  {allSections?.sections?.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.title}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="mb-2">
              <label htmlFor="" className="form-label mb-1">
                Descriptions
              </label>
              {/* <ReactQuill value={sectiondesp} onChange={(content) => setSectionDesp(content)} className='Description_quill' /> */}
              <textarea
                className="form-control form-control-sm"
                rows="5"
                required
                onChange={(e) => setSectionDesp(e.target.value)}
                value={sectiondesp}
              ></textarea>

            </div>
            {(formdata.formType === ASSESSMENTFORMTXT || formdata.formType === GENERAL_FORM) && (
              <div><div className="mb-2">
                <div className='row '>
                  <div className="col-md-6">
                    {" "}
                    <label htmlFor="" className="form-label mb-1">
                      Scoring method
                    </label>
                    <select
                      className="form-select w-100 form-select-sm"
                      required
                      id="scoringmethods"
                      onChange={(e) => setScoringMethod(e.target.value)}
                      value={scoringmethod}
                    >
                      {SCORINGMETHODS.map((opt) => (
                        <option key={opt.key} value={opt.key}>
                          {opt.name}
                        </option>
                      ))}
                    </select>
                    {scoringmethod != "NONE" && (
                      <small className="desc-txt">
                        Score of the section will be calculated as the{" "}
                        <span className="text-lower">{scoringmethod}</span>{" "}
                        {scoringmethod == "AVERAGE" && <span>score</span>} of all
                        the questions in this section
                      </small>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="" className="form-label mb-1">
                      Weightage (%)
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="weightagetxt"
                      inputMode="numeric"
                      onChange={(e) => {
                        const val = e.target.value.replace(/[^0-9]/g, "");
                        setWeightage(val);
                      }}
                      value={weightage}
                    />
                    <small className="desc-txt">
                      {weightage}% of the score in the form will be taken from
                      this section
                    </small>
                  </div>
                </div>

              </div>
                <div className="mb-2">
                  <div className='row'>
                    {getUOMRequiredCheckboxPopup()}
                    {uomRequiredPopup &&
                      <div className="col-md-12 mt-2">

                        <Typeahead
                          id="uom-popup-select"
                          className="uom-popup-select"
                          size="sm"
                          clearButton
                          labelKey="label"
                          options={uniqueOutputUnits}
                          placeholder="Select"
                          selected={uniqueOutputUnits.filter(u => u.value === uom_popup)}
                          onChange={(selected) => setUomPopup(selected[0]?.value ?? '')}
                        />
                      </div>
                    }
                  </div>

                </div>
                {/* <div className="mb-3  d-flex">
                  {getMultiSupportEnabledCheckboxInPopup()}
                </div> */}
              </div>
            )}

            <div className="text-center p-2">
              <button
                type="button"
                className="btn btn-secondary px-4 me-2"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary px-4 sbmBtn">
                {editedSectionId != null ? (
                  <span>Update</span>
                ) : (
                  <span>Create</span>
                )}
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {isConfirmModal &&
        <ConfirmationModal
          modalShow={true}
          messageText={confirmMessage}
          callbackModal={callbackdelete}
        />
      }
      {isDeleteSection &&
        <DeleteSectionModal
          modalShow={true}
          callbackModal={callbackDeleteSection}
        />
      }
    </div >
  )
};

export default FormMainBody;
